import { gql, insertGraphQLFragments, simplifyGraphQLJSON } from '../GraphQLClient';
import { fragmentUserBasic, serializeUserBasic } from './serializeUser';
import { fragmentFileBasic, serializeFileBasic } from './serializeFile';
import { defaultsTo } from '../../utils/utilsGlobal';
import { serializeMessageBasic } from './serializeMessage';


export const fragmentRoomBasic = insertGraphQLFragments(gql`
  fragment fragmentRoomBasic on Room {
    id
    title
    unreadMessagesCount
    isCaseOpen
    lastMessageAt
    insertedAt
    avatar { ...fragmentFileBasic }
    omnichannelChannelType
    omnichannelClientId
    assignedEmployee {
      ...fragmentUserBasic
    }
  }
`, { fragmentUserBasic, fragmentFileBasic });


export const fragmentConnectedRoom = insertGraphQLFragments(gql`
  fragment fragmentConnectedRoom on ConnectedRoom {
    id
    toRoom { ...fragmentRoomBasic }
    toClient { ...fragmentUserBasic }
  }
`, { fragmentRoomBasic, fragmentUserBasic });


export const fragmentRoomFull = insertGraphQLFragments(gql`
  fragment fragmentRoomFull on Room {
    ...fragmentRoomBasic
    notes
    connectedRooms(first: 100) {
      edges {
        node { ...fragmentConnectedRoom }
      }
    }
    workHours {
      begin
      end
    }
    avgResponseTime
    avgCaseCloseTime
    foreignId
    foreignData {
      id
      value
      field {
        id
        name
        title
        type
        dictionary { foreignId, title }
      }
    }
    members {
      ...fragmentUserBasic
    }
  }
`, { fragmentRoomBasic, fragmentUserBasic, fragmentConnectedRoom });


export function serializeRoomBasic(data) {
  const { avatar, assignedEmployee, messages } = data || {};
  const serializedData = defaultsTo(data, {
    id: null,
    cursor: null,
    title: '',
    isCaseOpen: false,
    lastMessageAt: null,
    insertedAt: null,
    unreadMessagesCount: 0,
    omnichannelChannelType: null,
    omnichannelClientId: null,
  });
  return {
    ...serializedData,
    avatar: serializeFileBasic(avatar),
    messages: serializeMessageBasic(messages), // Messages are present in getIssueLinkedRooms(), see apiIssues.js
    assignedOperator: serializeUserBasic(assignedEmployee),
  };
}


export function serializeRoomFull(data) {
  const roomBasic = serializeRoomBasic(data);
  const serializedData = defaultsTo(data, {
    notes: '',
    foreignData: [],
    avgResponseTime: null,
    avgCaseCloseTime: null,
    workHours: null,
  });
  return {
    ...roomBasic,
    ...serializedData,
    members: (data?.members || []).map(serializeUserBasic),
    connectedRooms: simplifyGraphQLJSON(data?.connectedRooms).map(serializeConnectedRoom),
  }
}


export function serializeConnectedRoom(data){
  return {
    connectedRoomId: data?.id || null,
    toClient: serializeUserBasic(data?.toClient),
    toRoom: serializeRoomBasic(data?.toRoom),
  };
}
